import React, { useState, useCallback, useEffect, useRef } from 'react';
import styles from './Dept.module.scss';
import common from '../../../common';
import axios from 'axios';
import { useSelector } from 'react-redux';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Dept() {
    const { useAlert, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();

    const member_idx = useSelector((state) => state.user.loginInfo || null);




    const [years, setYears] = useState([]);
    const [depts, setDepts] = useState([]);
    const [user, setUser] = useState([]);
    const [selectedYear, setSelectedYear] = useState('');

    const handleYearClick = (year, yearIDX) => {
        setSelectedYear(year);
        fetchOrganizationData(yearIDX.toString());
    };

    const fetchOrganizationDataDept = useCallback(async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_organization/out/get_organization_dept_list`, {}, {
                withCredentials: true
            });

            if (response.data.result === 't') {
                const data = response.data.data;
                setDepts(data); // 부서 리스트 상태 업데이트
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            pAlert('실패함2.');
        } finally {
            pLoadingOff();
        }
    }, [pAlert, pLoadingOn, pLoadingOff]);

    const fetchOrganizationData = useCallback(async (yearTargetIdx) => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_organization/out/get_organization_detail`, { target_idx: yearTargetIdx }, {
                withCredentials: true
            });
    
            if (response.data.result === 't') {
                const data = response.data.data;
                setUser(data);
                
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            pAlert('리스트 불러오기 실패함.');
        } finally {
            pLoadingOff();
        }
    }, [pAlert, pLoadingOn, pLoadingOff]);

    const fetchOrganizationYear = useCallback(async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_organization/out/get_organization_year`, {}, {
                withCredentials: true
            });

            if (response.data.result === 't') {
                const data = response.data.data;
                data.sort((a, b) => parseInt(b.year) - parseInt(a.year));

                // 현재 연도 설정
                const currentYear = new Date().getFullYear();
                const currentYearData = data.find(yearData => parseInt(yearData.year) === currentYear);
                const currentYearIDX = currentYearData ? currentYearData.idx.toString() : '39'; // 일치하는 데이터가 없으면 기본값 39

                fetchOrganizationData(currentYearIDX);

                setYears(data);
                setSelectedYear(currentYearData ? currentYearData.year : '');
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            pAlert('실패함3.');
        } finally {
            pLoadingOff();
        }
    }, [pAlert, pLoadingOn, pLoadingOff, fetchOrganizationData]);

    useEffect(() => {
        fetchOrganizationYear();
        fetchOrganizationDataDept();
    }, []);

    // =================================

    const sortDepts = (depts) => {
        const specialDepts = ['학교대표', '상임위원'];
        const filteredDepts = depts.filter(dept => !specialDepts.includes(dept.dept));
        const specialDeptsFiltered = depts.filter(dept => specialDepts.includes(dept.dept));
        return filteredDepts.sort((a, b) => a.idx - b.idx).concat(specialDeptsFiltered);
    };


    const getPositionBoxes = (dept) => {
        const positions = user
            .filter(userDept => userDept.deptName === dept.dept)
            .flatMap(userDept => userDept.list.map(member => member.position));


        if (positions.length === 0) {
            return null;
        }


        if (dept.dept === '학교대표' || dept.dept === '상임위원') {
            return <div className={styles.position_box_empty}></div>;
        }

        

        return (
            <>
                <div className={styles.position_2_box}>
                    {positions.includes('부회장') && <div className={`${styles.position_box} ${styles.position_2}`}>부회장</div>}
                </div>
                <div className={styles.position_box_bg}>
                    {positions.includes('부장') && <div className={styles.position_box}>부장</div>}
                    {positions.includes('차장') && <div className={styles.position_box}>차장</div>}
                </div>
                
            </>
        );
    };



    const currentYear = new Date().getFullYear();
    const [activeYear, setActiveYear] = useState(currentYear); // 활성화된 연도를 추적하는 상태
    const scrollRef = useRef(null);
    let isDown = false;
    let startX;
    let scrollLeft;

    const mouseDownHandler = (e) => {
        isDown = true;
        scrollRef.current.classList.add(styles.active);
        startX = e.pageX - scrollRef.current.offsetLeft;
        scrollLeft = scrollRef.current.scrollLeft;
    };

    const mouseLeaveHandler = () => {
        isDown = false;
        scrollRef.current.classList.remove(styles.active);
    };

    const mouseUpHandler = () => {
        isDown = false;
        scrollRef.current.classList.remove(styles.active);
    };

    const mouseMoveHandler = (e) => {
        if (!isDown) return; // if mouse is not down, return
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX) * 2; // The multiplier controls the scroll speed
        scrollRef.current.scrollLeft = scrollLeft - walk;
    };







    const handleLinkClick = (e) => {
        if (!member_idx || (typeof member_idx === 'object' && Object.keys(member_idx).length === 0)) {
            e.preventDefault(); // 링크 이동을 막음
            pAlert('로그인 상태에서 이용하실 수 있습니다.');
            return false;
        }
    };



    return (
        <>
            <AlertComponent />
            <LoadingComponent />
            <div className={styles.components_wrap}>
                <span className='components_wrap_title'>조직 구성</span>
                <div 
                    className={styles.dept_years_container}
                    ref={scrollRef}
                    onMouseDown={mouseDownHandler}
                    onMouseLeave={mouseLeaveHandler}
                    onMouseUp={mouseUpHandler}
                    onMouseMove={mouseMoveHandler}
                    
                    >
                    {years.map(year => (
                        <button
                            key={year.idx}
                            className={`${styles.dept_year} ${selectedYear === year.year ? styles.selected : ''}`}
                            onClick={() => handleYearClick(year.year, year.idx)}
                        >
                            {year.year}
                        </button>
                    ))}
                </div>
                <div className={styles.organization_chart}>
                    <div className={styles.position_title}>회장</div>
                    <div className={styles.position_row}>
                    {depts
                        .filter(dept => dept.dept !== '회장')
                        .sort((a, b) => a.idx - b.idx)
                        .reduce((acc, dept) => {
                            if (dept.dept === '학교대표' || dept.dept === '상임위원') {
                                acc.special.push(dept);
                            } else {
                                acc.normal.push(dept);
                            }
                            return acc;
                        }, { normal: [], special: [] })
                        .normal.concat(depts
                            .filter(dept => dept.dept === '학교대표' || dept.dept === '상임위원')
                            .sort((a, b) => a.idx - b.idx))
                        .map((dept, index) => {
                            const positionBoxes = getPositionBoxes(dept);

                            // positionBoxes가 null일 경우, 전체 div를 렌더링하지 않음
                            if (!positionBoxes) {
                                return null;
                            }

                            return (
                                <div key={dept.idx} className={`${styles.position_col}`}>
                                    <div className={`${styles.sub_title} ${dept.dept === '학교대표' || dept.dept === '상임위원' ? styles.special_dept : ''}`}>
                                        {dept.dept}
                                    </div>
                                    {positionBoxes}
                                </div>
                            );
                        })
                    }
                    </div>
                </div>
                <div className={styles.info_message}>
                    성명을 클릭하면 상세정보를 보실 수 있습니다.
                </div>
                <table className={styles.info_table}>
                <thead>
                    <tr>
                        <th>부서</th>
                        <th>직위</th>
                        <th>성명</th>
                        <th>소속학교</th>
                    </tr>
                </thead>
                <tbody>
                    {user.map(dept => (
                        dept.list.map((member, index) => (
                            <tr
                                key={`${dept.deptIDX}-${member.idx}`}
                                className={dept.deptIDX % 2 === 0 ? styles.tr_odd : styles.tr_even}
                            >
                                {index === 0 && (
                                    <td rowSpan={dept.list.length}>{dept.deptName}</td>
                                )}
                                <td>{member.position || ''}</td>
                                <td className={styles.td_bold}>
                                    <a href={`/userdetail?id=${member.memberIDX}`} onClick={handleLinkClick}>
                                        <span>{member.name}</span>
                                    </a>
                                </td>
                                <td>{member.university || ''}</td>
                            </tr>
                        ))
                    ))}
                </tbody>
            </table>
            </div>
        </>
    );
}

export default Dept;
